import { PlanType } from '@/shared/types/store';

export enum OfferingTypeKeys {
  BUSINESS_PLAN = 'BUSINESS_PLAN',
  SOURCING = 'SOURCING',
  FULFILLMENT = 'FULFILLMENT',
  SALES_CHANNELS = 'SALES_CHANNELS',
}

export interface OfferingType {
  key: OfferingTypeKeys;
  icon: string;
  title: string;
  description: string[];
}

export interface FAQType {
  question: string;
  answer: string;
}

export interface IMembershipFeature {
  id: string;
  image: string;
  title: string;
  description: string;
  buttonText: string;
}

export interface CreatorSubscriptionPlan {
  planType: PlanType;
  title: string;
  subtitle: string;
  price: number;
  features: string[];
  stripeProductName: string;
}

export enum PietraPlanModuleType {
  PRINT_ON_DEMAND = 'PrintOnDemand',
  BUSINESS_PLANNING_TOOLS = 'BusinessPlanningTools',
  WEEKLY_WORKSHOPS = 'WeeklyWorkshops',
  PRODUCT_DESIGN = 'ProductDesign',
  SOURCING = 'SourcingAndManufacturing',
  ORDER_FULFILLMENT = 'StorageAndFulfillment',
  PREMIUM_ORDER_FULFILLMENT = 'PremiumStorageAndFulfillment',
  STOREFRONT = 'Storefront',
  MARKETING_TOOLS = 'EmailAndSMS',
  MARKETING_TOOLS_EMAIL = 'Email',
  MARKETING_TOOLS_SMS = 'SMS',
  MARKETING_TOOLS_AFFILIATE = 'Affiliate',
  DATA_AND_ANALYTICS = 'DataAndAnalytics',
  SALES_CHANNELS = 'SalesChannels',
  BEGINNER_BUNDLE = 'BeginnerBundle',
  PROFESSIONAL_BUNDLE = 'ProfessionalBundle',
  LAUNCH_BUNDLE = 'LaunchBundle',
  DESIGN_AND_SAMPLE_BUNDLE = 'DesignAndSampleBundle',
  GROW_BUNDLE = 'GrowBundle',
  CUSTOM = 'Custom',
}

export interface PietraPlanModuleCard {
  moduleType: PietraPlanModuleType;
  icon: string;
  description: string;
  moduleAttributes: string[];
  attributeHeader?: string;
  attributeHeader2?: string;
  moduleAttributes2?: string[];
  benefit?: string;
  callOut?: string;
  bundledModuleTypes?: PietraPlanModuleType[];
  lastAtrrHideMark?: boolean;
  link?: {
    url: string;
    text: string;
  };
}

export enum BillingOption {
  MONTH = 'month',
  QUARTERLY = 'quarterly',
  YEAR = 'year',
}
